/* React */
import React from "react";

/* Stylesheet */
import styles from "./Content.module.scss";

const Content: React.FC = () => {
  return (
    <div className={styles.content}>
      <div className={styles.address}>
        <h4 className={styles.title}>
          Information Pursant To Sect. 5 German Telemedia
          Act (TMG) <br /> and § 14 Austrian Commercial Code
          (UGB)
        </h4>
        <p className={styles.paragraph}>
          <h6 className={styles.subtitle}>Company</h6>
          Syndena GmbH <br />
          Innrain 66a <br />
          6020 Innsbruck, Austria <br />
        </p>
        <p className={styles.paragraph}>
          <h6 className={styles.subtitle}>
            Commercial Register Information
          </h6>
          Company Register Number: FN 318548 d <br />
          Commercial Court: Landesgericht Innsbruck <br />
          VAT ID: ATU64536700 <br />
        </p>
        <p className={styles.paragraph}>
          <h6 className={styles.subtitle}>
            Represented by
          </h6>
          Roman Weger
        </p>
        <p className={styles.paragraph}>
          <h6 className={styles.subtitle}>Contact</h6>
          Phone:{" "}
          <a href="tel:+43 699 104 067 39">
            +43 699 104 067 39
          </a>
          <br />
          E-mail:{" "}
          <a href="mailto:roman.weger@syndena.com">
            roman.weger@syndena.com
          </a>
          <br />
          Website:{" "}
          <a
            href="https://www.syndena.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.syndena.com
          </a>
          <br />
        </p>
        <p className={styles.paragraph}>
          <h6 className={styles.subtitle}>Disclaimer</h6>
          We are not willing or obliged to participate in
          dispute resolution proceedings before a consumer
          arbitration board.
        </p>
      </div>
      <div className={styles.contact}>
        <h4 className={`${styles.title}`}></h4>
      </div>
    </div>
  );
};

export default Content;
